export const state = () => ({
  offices_filter: [],
  latest_filter: [],
})

export const getters = {
  getOfficesFilter(state) {
    return state.offices_filter
  },
  getLatestFilter(state) {
    return state.latest_filter
  },
}

export const mutations = {
  SET_OFFICES_FILTER(state, value) {
    state.offices_filter = value
  },
  SET_LATEST_FILTER(state, value) {
    state.latest_filter = value
  },
}

export const actions = {
  async officesFilter({ dispatch, commit }) {
    dispatch('loading/startBusyState', null, { root: true })
    await this.$storyapi
      .get(`cdn/datasource_entries?datasource=offices-filter`)
      .then((res) => {
        dispatch('loading/stopBusyState', null, { root: true })
        commit('SET_OFFICES_FILTER', res.data.datasource_entries)
        return res.data
      })
      .catch((res) => {
        return res
      })
  },
  async latestFilter({ dispatch, commit }) {
    dispatch('loading/startBusyState', null, { root: true })
    await this.$storyapi
      .get(`cdn/datasource_entries?datasource=news-insights-filter`)
      .then((res) => {
        dispatch('loading/stopBusyState', null, { root: true })
        commit('SET_LATEST_FILTER', res.data.datasource_entries)
        return res.data
      })
      .catch((res) => {
        return res
      })
  },
}
